module.exports = __webpack_public_path__ + "static/media/sentiment_satisfied.466ea94a.svg";